<template>
  <v-dialog v-model="data.useDialog" :persistent="data.persistent" :width="data.getWidth">
    <div class="dialogCon">
      <div v-html="data.messageHTML"></div>
      <div class="btn" style="display: flex; gap: 6px; justify-content: center">
        <!-- Left button -->
        <v-btn class="UXbtn" outline round style="width: 86px; min-width: 86px" @click="handleLeft">
          {{ data.getLeftBtnName }}
        </v-btn>

        <!-- Middle button (primary) -->
        <v-btn
          v-if="!data.isLoading && data.getBtnName"
          class="UXbtn"
          color="#5578F0"
          dark
          round
          style="width: 86px; min-width: 86px"
          @click="handleMiddle"
        >
          {{ data.getBtnName }}
        </v-btn>
        <v-btn
          v-else-if="data.isLoading && data.getBtnName"
          :loading="data.dialog"
          class="UXbtn"
          color="#5578F0"
          dark
          round
          style="width: 86px; min-width: 86px"
          @click="changeLoading"
        >
          {{ data.getBtnName }}
        </v-btn>

        <!-- Right button -->
        <v-btn class="UXbtn" color="#5578F0" dark round style="width: 86px; min-width: 86px" @click="handleRight">
          {{ data.getRightBtnName }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import util from '@/util';

export default {
  name: 'ThreeBtnDialogPopup',
  data() {
    return {
      data: {
        useDialog: false,
        persistent: true,
        getWidth: 400,
        messageHTML: '',
        getBtnName: '확인',
        getLeftBtnName: '취소',
        getRightBtnName: '',
        getButtonEvent: () => {},
        getLeftBtnEvent: () => {},
        getRightBtnEvent: () => {},
        isLoading: false,
        dialog: false
      }
    };
  },
  mounted() {
    this.initialize();
  },
  destroyed() {
    // this.$eventBus.$off('ThreeBtnDialogPopup');
  },
  methods: {
    initialize() {
      const defaultData = () => ({
        useDialog: false,
        persistent: true,
        getWidth: 400,
        messageHTML: '',
        getBtnName: '확인',
        getLeftBtnName: '취소',
        getRightBtnName: '',
        isLoading: false,
        dialog: false,
        getButtonEvent: () => {},
        getLeftBtnEvent: () => {},
        getRightBtnEvent: () => {}
      });

      this.data = defaultData();

      this.$eventBus.$on('ThreeBtnDialogPopup', (val) => {
        try {
          if (!this.data.useDialog) {
            this.data.useDialog = val.useDialog || defaultData().useDialog;
            this.data.persistent = val.persistent || defaultData().persistent;
            this.data.getWidth = val.getWidth || defaultData().getWidth;
            this.data.messageHTML = util.replaceNewLine(val.messageHTML || defaultData().messageHTML);
            this.data.getBtnName = val.getBtnName || defaultData().getBtnName;
            this.data.getLeftBtnName = val.getLeftBtnName || defaultData().getLeftBtnName;
            this.data.getRightBtnName = val.getRightBtnName || defaultData().getRightBtnName;
            this.data.isLoading = val.isLoading || defaultData().isLoading;
            this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent;
            this.data.getLeftBtnEvent = val.getLeftBtnEvent || defaultData().getLeftBtnEvent;
            this.data.getRightBtnEvent = val.getRightBtnEvent || defaultData().getRightBtnEvent;
            this.data.dialog = false;
          }
        } catch (e) {
          console.log(e);
        }
      });
      this.$eventBus.$on('ClosePopup', () => this.closePopup());
    },
    // 부모 컴포넌트에서 직접 호출하도록 public API 제공
    openPopup(val) {
      try {
        const defaultData = () => ({
          useDialog: false,
          persistent: true,
          getWidth: 400,
          messageHTML: '',
          getBtnName: '확인',
          getLeftBtnName: '취소',
          getRightBtnName: '',
          isLoading: false,
          dialog: false,
          getButtonEvent: () => {},
          getLeftBtnEvent: () => {},
          getRightBtnEvent: () => {}
        });

        if (!val) return;

        this.data.useDialog = val.useDialog || defaultData().useDialog;
        this.data.persistent = val.persistent || defaultData().persistent;
        this.data.getWidth = val.getWidth || defaultData().getWidth;
        this.data.messageHTML = util.replaceNewLine(val.messageHTML || defaultData().messageHTML);
        this.data.getBtnName = val.getBtnName || defaultData().getBtnName;
        this.data.getLeftBtnName = val.getLeftBtnName || defaultData().getLeftBtnName;
        this.data.getRightBtnName = val.getRightBtnName || defaultData().getRightBtnName;
        this.data.isLoading = val.isLoading || defaultData().isLoading;
        this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent;
        this.data.getLeftBtnEvent = val.getLeftBtnEvent || defaultData().getLeftBtnEvent;
        this.data.getRightBtnEvent = val.getRightBtnEvent || defaultData().getRightBtnEvent;
        this.data.dialog = false;
      } catch (e) {
        console.log(e);
      }
    },
    changeLoading() {
      this.data.dialog = true;
    },
    closePopup() {
      this.data.useDialog = false;
    },
    handleLeft() {
      try {
        this.data.getLeftBtnEvent();
      } catch (e) {
        console.log(e);
      }
      this.closePopup();
    },
    handleMiddle() {
      try {
        this.data.getButtonEvent();
      } catch (e) {
        console.log(e);
      }
      this.closePopup();
    },
    handleRight() {
      try {
        this.data.getRightBtnEvent();
      } catch (e) {
        console.log(e);
      }
      this.closePopup();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ThreeBtnDialogPopup.vue